"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncValidate = exports.validate = undefined;

var _revalidate = require("revalidate");

var _vat = require("redux/modules/vat");

var _address = require("redux/modules/address");

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = exports.validate = (0, _revalidate.combineValidators)({
  name: (0, _revalidate.isRequired)({ message: "This is who will be invoiced" }),
  postalCode: (0, _revalidate.isRequired)({ message: "Postal code is required" })
});

var asyncValidate = exports.asyncValidate = function asyncValidate(values, dispatch) {
  if (values.vatNo) {
    if (values.isVatValid === false) {
      return _bluebird2.default.resolve({ vatNo: "We are unable to verify your VAT ID" });
    }

    return dispatch((0, _vat.validateVat)({ vatNo: values.vatNo })).then(function (response) {
      if (response.vatNo == values.vatNo) {
        return null;
      }
    }).catch(function (err) {
      if (err) {
        return {
          vatNo: "We are unable to verify your VAT ID"
        };
      }
    });
  } else if (values.postalCode) {
    if (values.country === "US" || values.country === "CA") {
      return dispatch((0, _address.validatePostalCode)({
        postalCode: values.postalCode,
        countryCode: values.country
      })).then(function (res) {
        if (res.code === "INVALID_CUSTOMER_INFO") {
          throw new Error(); // passing the control to .catch below
        }
      }).catch(function (err) {
        return {
          postalCode: "Postal Code seems to be invalid"
        };
      });
    } else {
      return _bluebird2.default.resolve();
    }
  } else {
    return _bluebird2.default.resolve();
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/addressFormValidation.js
// module id = 2804
// module chunks = 0